import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form } from "semantic-ui-react";
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import "./test.css";
import ControlTitle from "../ControlTitle";

class TextField extends Component {
  shouldComponentUpdate(nextProps) {
    const different =
      this.props.element_value !== nextProps.element_value ||
      this.props.error !== nextProps.error ||
      this.props.validate !== nextProps.validate;
    return different;
  }

  handleChange(date) {
    if (date === null) {
      this.props.onChange(this.props.repeatingForm, this.props.element_id, "");
    } else {
      this.props.onChange(
        this.props.repeatingForm,
        this.props.element_id,
        date.format("DD/MM/YYYY")
      );
    }
  }

  handleDTChange(date) {
    if (date === null) {
      this.props.onChange(this.props.repeatingForm, this.props.element_id, "");
    } else {
      this.props.onChange(
        this.props.repeatingForm,
        this.props.element_id,
        date.format("DD/MM/YYYY HH:mm")
      );
    }
  }

  handleTimeChange(date) {
    if (date === null) {
      this.props.onChange(this.props.repeatingForm, this.props.element_id, "");
    } else {
      this.props.onChange(
        this.props.repeatingForm,
        this.props.element_id,
        date.format("HH:mm")
      );
    }
  }

  renderTimePicker() {
    const { element_value, validate, error } = this.props;

    if (validate && error) {
      return (
        <DatePicker
          ref="ddd"
          onFocus={this.shouldBlur}
          className="error"
          onChange={this.handleTimeChange.bind(this)}
          selected={
            element_value === "" ? null : moment(element_value, "HH:mm")
          }
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={5}
          timeFormat="HH:mm"
          dateFormat="HH:mm"
          timeCaption="Time"
        />
      );
    }

    return (
      <DatePicker
        ref="ddd"
        onFocus={this.shouldBlur}
        onChange={this.handleTimeChange.bind(this)}
        value={element_value}
        selected={element_value === "" ? null : moment(element_value, "HH:mm")}
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={5}
        timeFormat="HH:mm"
        dateFormat="HH:mm"
        timeCaption="Time"
      />
    );
  }

  shouldBlur = e => {
    e.target.blur();
  };

  renderDateTimePicker() {
    const { element_value, validate, error } = this.props;

    if (validate && error) {
      return (
        <DatePicker
          className="error"
          ref="ddd"
          onFocus={this.shouldBlur}
          selected={
            element_value === ""
              ? null
              : moment(element_value, "DD/MM/YYYY HH:mm")
          }
          onChange={this.handleDTChange.bind(this)}
          peekNextMonth
          showTimeSelect={true}
          timeIntervals={5}
          timeFormat="HH:mm"
          dateFormat="DD/MM/YYYY HH:mm"
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
        />
      );
    }

    return (
      <DatePicker
        ref="ddd"
        onFocus={this.shouldBlur}
        selected={
          element_value === ""
            ? null
            : moment(element_value, "DD/MM/YYYY HH:mm")
        }
        onChange={this.handleDTChange.bind(this)}
        peekNextMonth
        showTimeSelect={true}
        timeIntervals={5}
        timeFormat="HH:mm"
        dateFormat="DD/MM/YYYY HH:mm"
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
      />
    );
  }

  renderDatePicker() {
    const { element_value, validate, error } = this.props;

    if (validate && error) {
      return (
        <DatePicker
          className="error"
          ref="ddd"
          onFocus={this.shouldBlur}
          selected={
            element_value === "" ? null : moment(element_value, "DD/MM/YYYY")
          }
          onChange={this.handleChange.bind(this)}
          peekNextMonth
          dateFormat="DD/MM/YYYY"
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
        />
      );
    }

    return (
      <DatePicker
        ref="ddd"
        onFocus={this.shouldBlur}
        selected={
          element_value === "" ? null : moment(element_value, "DD/MM/YYYY")
        }
        onChange={this.handleChange.bind(this)}
        peekNextMonth
        dateFormat="DD/MM/YYYY"
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
      />
    );
  }

  renderPicker() {
    if (this.props.element_params.N === "time") {
      return <div>{this.renderTimePicker()}</div>;
    }

    if (this.props.element_params.N === "datetime") {
      return <div>{this.renderDateTimePicker()}</div>;
    }

    return <div>{this.renderDatePicker()}</div>;
  }

  render() {
    const { element_prompt, element_value, ...formControl } = this.props;

    return (
      <div className="formControlItem">
        <Form.Field>
          <ControlTitle
            text={element_prompt}
            optional={formControl.element_optional === "1" ? true : false}
          ></ControlTitle>
          {this.renderPicker()}
        </Form.Field>
      </div>
    );
  }
}

TextField.propTypes = {
  element_prompt: PropTypes.string.isRequired,
  element_id: PropTypes.number.isRequired,
  element_value: PropTypes.string.isRequired,
  error: PropTypes.bool.isRequired,
  validate: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};

export default TextField;



// WEBPACK FOOTER //
// ./src/components/DateField/index.js